const SesameStreetIDontWantToLiveOnTheMoon = [
	'[Verse 1]',
	"Well, I'd like to visit the moon",
	'On a rocket ship high in the air',
	"Yes, I'd like to visit the moon",
	"But I don't think I'd like to live there",
	"Though I'd like to look down at the earth from above",
	'I would miss all the places and people I love',
	'So although I might like it for one afternoon',
	"I don't want to live on the moon",
	'',
	'[Verse 2]',
	"I'd like to travel under the sea",
	'I could meet all the fish everywhere',
	"Yes, I'd travel under the sea",
	"But I don't think I'd like to live there",
	'I might stay for a day there if I had my wish',
	"But there's not much to do when your friends are all fish",
	"And an oyster and clam aren't real family",
	"So I don't want to live in the sea",
	'',
	"I'd like to visit the jungle, hear the lions roar",
	'Go back in time and meet a dinosaur',
	"There's so many strange places I'd like to be",
	'But none of them permanently',
	'',
	'[Verse 3]',
	'So if I should visit the moon',
	"Well, I'll dance on a moonbeam and then",
	'I will make a wish on a star',
	"And I'll wish I was home once again",
	"Though I'd like to look down at the earth from above",
	'I would miss all the places and people I love',
	"So although I may go I'll be coming home soon",
	"'Cause I don't want to live on the moon",
	"No, I don't want to live on the moon",
];

export default SesameStreetIDontWantToLiveOnTheMoon;
